import React from 'react';
import Const from 'const.json';
import BasePeriodSelector from './BasePeriodSelector/BasePeriodSelector';
import { SelectionProps, ButtonQuarterlyData } from 'types/PeriodSelectionTypes'
import { QuartersEnum, SelectionTypeEnum } from 'enums/enums';

import Q1Icon from 'assets/icons/q1.svg'
import Q2Icon from 'assets/icons/q2.svg'
import Q3Icon from 'assets/icons/q3.svg'
import Q4Icon from 'assets/icons/q4.svg'
import Icon from 'components/ui/Icon';

import { monthsMap, SelectionChangeHandler } from 'utils/utilsLogic'

const buttonData: ButtonQuarterlyData[] = [
  {
    months: monthsMap[QuartersEnum.Quarterly1],
    description: 'רבעון 1',
    monthRange: 'ינואר - מרץ',
    icon: <Icon src={Q1Icon} alt="quarterly1Icon" />
  },
  {
    months: monthsMap[QuartersEnum.Quarterly2],
    description: 'רבעון 2',
    monthRange: 'אפריל - יוני',
    icon: <Icon src={Q2Icon} alt="quarterly2Icon" />

  },
  {
    months: monthsMap[QuartersEnum.Quarterly3],
    description: 'רבעון 3',
    monthRange: 'יולי - ספטמבר',
    icon: <Icon src={Q3Icon} alt="quarterly3Icon" />

  },
  {
    months: monthsMap[QuartersEnum.Quarterly4],
    description: 'רבעון 4',
    monthRange: 'אוקטובר - דצמבר',
    icon: <Icon src={Q4Icon} alt="quarterly4Icon" />
  },
];

const QuarterlySelection: React.FC<SelectionProps> = (SelectionProps) => {

  const renderButtonContent = buttonData => (
    <div className='quarterlyPeriod'>
      {buttonData.icon}
      <p className='m-0 mt-2 bold'>{buttonData.description}</p>
      <p className='m-0 text-nowrap fs-7'>{buttonData.monthRange}</p>
    </div>
  );

  const handleSelectionChange = SelectionChangeHandler(SelectionTypeEnum.Quarterly, SelectionProps);

  return (
    <BasePeriodSelector
      selectionMode='multiple'
      periods={buttonData}
      renderButtonContent={renderButtonContent}
      selectionLabel={Const.quarterlySelection}
      maxSelection={Const.QUARTERLY_MAX_SELECTIONS}
      onSelectionChange={handleSelectionChange}
      indexes={SelectionProps.indexes}
    />
  );
};

export default QuarterlySelection;
